import { CopyCTA } from '@livecontrol/core-ui';
import { Icons } from '@livecontrol/scheduler/components';
import _ from 'lodash';
import React from 'react';
import { OverlayTrigger, Tooltip } from 'react-bootstrap';
import type { Destination} from '../graphql-types';
import { DestinationType, EventVisibility } from '../graphql-types';

export const DestinationsList = ({
  stream_rtmp,
  stream_youtube,
  stream_facebook,
  stream_live,
  stream_zoom,
  zoom_meeting_id,
  zoom_password,
  visibility,
  hidden,
  destinations
}: {
  stream_rtmp?: boolean;
  stream_youtube?: boolean;
  stream_facebook?: boolean;
  stream_live?: boolean;
  stream_zoom?: boolean;
  zoom_meeting_id?: string;
  zoom_password?: string;
  hidden?: boolean;
  visibility?: EventVisibility;
  destinations?: Destination[];
}): React.ReactElement => (
  <span className='d-flex align-items-center'>
    {(visibility === EventVisibility.Private || hidden) ? (
      <i className='fas fa-eye-slash' />
    ) : (
      <>
        {stream_rtmp && (destinations !== undefined ? destinations.some(destination => destination.type === DestinationType.Rtmp) : true) && <i className='mr-8px fas fa-signal-stream' />}
        {stream_youtube && (destinations !== undefined ? destinations.some(destination => destination.type === DestinationType.YouTube): true) && <i className='mr-8px fab fa-youtube' />}
        {stream_facebook && (destinations !== undefined ? destinations.some(destination => destination.type === DestinationType.Facebook) : true) && <i className='mr-8px fab fa-facebook' />}
        {stream_live && <Icons.LcIcon color='white' className='mr-8px' />}
        {stream_zoom && zoom_meeting_id ? (
          <CopyCTA noIcon toastText='Zoom Details Copied' value={`Meeting ID: ${zoom_meeting_id}${zoom_password ? `\nPassword: ${zoom_password}` : ''}`}>
            <OverlayTrigger
              placement='bottom'
              overlay={
                <Tooltip id={_.uniqueId('tooltip')}>
                  <p className='m-0 text-left'>Meeting ID: {zoom_meeting_id}</p>
                  {zoom_password && (
                    <p className='m-0 text-left'>Password: {zoom_password}</p>
                  )}
                </Tooltip>
              }
            >
              <button type='button' className='x-pseudo'>
                <i className='mr-8px fa fa-video' />
              </button>
            </OverlayTrigger>
          </CopyCTA>
        ) : stream_zoom ? (
          <i className='mr-8px fa fa-video' />
        ) : null}
      </>
    )}
  </span>
)